import {StorageSource} from './StorageSource';

interface AzureCdnEndpoint {
    name: string;
    hostname: string;
}

export enum CustomDomainState {
    CNAME_PENDING = 0,
    CNAME_VERIFIED = 1,
    DOMAIN_PENDING = 2,
    DOMAIN_VERIFIED = 3,
    DOMAIN_READY = 4,
    DOMAIN_ERROR = 5,
}

enum CustomDomainType {
    AZURE = 1,
}

export interface CustomDomain {
    hostname: string;
    type: CustomDomainType;
    azure_cdn_endpoint: AzureCdnEndpoint | null;
    state: CustomDomainState;
    metadata: any;
    organization_storage_source: StorageSource | null;
    enable_media_urls: boolean;
}

export interface CustomDomainRequest {
    hostname: string;
    org_storage_source?: string;
    enable_media_urls?: boolean;
}
